// The Check Teachers screen's reading of a row's warnings
// (TeacherData::TeacherChecks): the summary at the top of the page and the
// list on each row say the same thing from this one place.

// What each warning code means, in a few words.
export const WARNING_LABELS = {
  small_class: 'unusually small class',
  display_name: 'display name not First Last / Salutation Last',
  display_grade: 'display grade not written out',
  linked_record: 'linked staff record missing, named differently, or without this season\'s picture',
};

// Warnings that would print wrong; a notice is a style nit and flags nothing.
const realWarnings = (teacher) => (teacher.warnings || [])
  .filter((w) => w.level === 'warning' || w.level === 'alert');

// The labels of one row's problems, each once.
export const rowProblemLabels = (teacher) => (
  [...new Set(realWarnings(teacher).map((w) => WARNING_LABELS[w.code] || w.code))]
);

// How many teachers need a look, and which teachers have each kind of problem.
export const summarizeTeacherWarnings = (teachers) => {
  const names = {};
  let flagged = 0;
  teachers.forEach((teacher) => {
    const real = realWarnings(teacher);
    if (real.length) flagged += 1;
    [...new Set(real.map((w) => w.code))].forEach((code) => {
      names[code] = [...(names[code] || []), teacher.display_name || teacher.teacher_name];
    });
  });
  return { flagged, names };
};

// The summary's detail: "4 display grade not written out (Mrs. Dougherty, ...)".
export const summaryDetail = (names) => Object.keys(names)
  .map((code) => `${names[code].length} ${WARNING_LABELS[code] || code} (${names[code].join(', ')})`)
  .join('; ');
